import axios, { AxiosResponse } from 'axios';
import { handleResponseError } from './helper';
import { responseHelpers } from '../../helpers';
import { userServices } from '../../services';
import '@terra-js/web-bridge';
import TerraKit from '@terra-js/terra-kit';
import {
  responseConstants,
  localStorageConstants,
  localizationConstants,
} from 'constants/index';

const { CODE_TOKEN_EXPIRED, STATUS_UNAUTHORIZE } = responseConstants;
const { COMPANY_ID, LOCALIZATION } = localStorageConstants;
const { REGIONS } = localizationConstants;

export const promotionClient = axios.create({
  baseURL: `${window.REACT_APP_TICKET_DOMAIN}/api/v1`,
  headers: {
    'x-api-key': 'AIzaSyC2JyaAhVwDcTxXWx9riZVilhYY35cTCpY',
  },
});

export const merchantServiceClient = axios.create({
  baseURL: `https://api-partner.vnpaytest.vn/api/contents`,
  headers: {
    'x-api-key': 'AIzaSyC2JyaAhVwDcTxXWx9riZVilhYY35cTCpY',
  },
});

export const merchantService = axios.create({
  baseURL: `https://api-pilot.vnpaytest.vn/merchant-service`,
});

export const ticketServiceClient = axios.create({
  baseURL: window.REACT_APP_TICKET_SERVICE,
});

export const locationServiceClient = axios.create({
  baseURL: `https://location.stage.tekoapis.net/api/v1/location`,
});

export const saleServiceClient = axios.create({
  baseURL: `https://api-pilot.vnpaytest.vn/sale-service`,
});

export const saleBffService = axios.create({
  baseURL: 'https://sale-portal-bff.dgl-dev.tekoapis.net',
});

export const bffServiceClient = axios.create({
  baseURL: window.REACT_APP_BFF_DOMAIN + '/api',
});

export const bffCommonServiceClient = axios.create({
  baseURL: window.REACT_APP_BFF_COMMON_DOMAIN + '/api',
});

const getAuthorization = async () => {
  return `Bearer ${await userServices.getAccessToken()}`;
};

// Do something before request is sent
const requestInterceptor = async (request: any) => {
  const companyId = localStorage.getItem(COMPANY_ID);
  request.headers.Authorization = await getAuthorization();
  if (companyId) request.headers['company-id'] = companyId;
  request.headers.language = localStorage.getItem(LOCALIZATION)
    ? localStorage.getItem(LOCALIZATION)
    : REGIONS.vi.key;
  return request;
};

// Any status code that lie within the range of 2xx cause this function to trigger
const responseSuccessInterceptor = (response: any) => {
  responseHelpers.handleResponseSuccess(response);
  return response;
};

// Any status codes that falls outside the range of 2xx cause this function to trigger
const responseErrorInterceptor = async (error: any) => {
  const recallPromise = await handleResponseError(error);
  return TerraKit.isAvailable() &&
    error?.response?.status === STATUS_UNAUTHORIZE &&
    error?.response?.data?.error?.code === CODE_TOKEN_EXPIRED
    ? recallPromise
    : Promise.reject(error);
};

export const resultData = (result: any) => {
  return (result as AxiosResponse).data;
};

const clients = [
  promotionClient,
  ticketServiceClient,
  bffServiceClient,
  bffCommonServiceClient,
];

clients.forEach(client => {
  client.interceptors.request.use(requestInterceptor);
  client.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );
});
